export default "__VITE_PUBLIC_ASSET__afa39b1a__"